import { render, staticRenderFns } from "./contas-receber.vue?vue&type=template&id=6a6bf0ba&scoped=true&"
import script from "./contas-receber.vue?vue&type=script&lang=js&"
export * from "./contas-receber.vue?vue&type=script&lang=js&"
import style0 from "./contas-receber.vue?vue&type=style&index=0&id=6a6bf0ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6bf0ba",
  null
  
)

export default component.exports